module.exports = __webpack_public_path__ + "static/media/ico-home.fecbe432.svg";